import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { FunctionLevel } from './function-level.interface';
export class FunctionLevelService {
   async getFunctionLevels(): Promise<ApiResource<Array<FunctionLevel>>> {
      const response = await http.get<ApiResource<Array<FunctionLevel>>>('/function-levels', { ...cacheFirstConfig });
      return response.data;
   }

   async getFunctionLevel() {
      throw Error('Method not implemented');
   }

   async postFunctionLevel() {
      throw Error('Method not implemented');
   }

   async putFunctionLevel() {
      throw Error('Method not implemented');
   }

   async deleteFunctionLevel() {
      throw Error('Method not implemented');
   }
}
